import { PlanningEntity } from 'src/entities/planningEntity';
import { RelaxedRuleVo } from 'src/vo/RelaxedRule.vo';

import { PlanningDialogSettings } from './usePlanningDialogSettings';

/**
 * `selectedRelaxedRules` / `priorityLargeTrucks` は `PlanningDialogSettings` の外にある
 * (`usePlanningDialogSettings.ts` 冒頭のコメント参照)。呼び出し側が別途持っているものを
 * ここで受け取り、`startOn` / `endOn` と合わせて `PlanningEntity` へ写す。
 */
export type BuildPlanningEntityContext = {
  startOn: string;
  endOn: string;
  selectedRelaxedRules: RelaxedRuleVo[];
  priorityLargeTrucks: number;
};

/**
 * カード配車が組み立てていた `PlanningEntity` の手組みをそのまま抽出したもの
 * (移設元: ConvenienceDispatches/Presenter.tsx 旧 :2416-2458)。
 * settings 由来 20 + ctx 由来 4 + 固定値 17 = 41 フィールド。
 *
 * Why not `PlanningEntity` の全 44 フィールドを埋めない: 残り 3 つ
 * (`timelineEditDeliveries` / `orderOperationCycleIndexes` / `createShiftParams`) は
 * optional で、移設元も未設定のまま渡していた（挙動不変の原則により広げない）。
 */
export function buildPlanningEntity(
  settings: PlanningDialogSettings,
  ctx: BuildPlanningEntityContext,
): PlanningEntity {
  return {
    startOn: ctx.startOn,
    endOn: ctx.endOn,
    lockType: 'free',
    isRespectRecent: false,
    excludeToll: settings.excludeToll,
    respectType: 'day_of_week',
    mlPlanning: false,
    respectDaysOfWeek: [],
    respectOn: '',
    isTimeTableBackward: false,
    includeFutureDeliveries: settings.includeFutureDeliveries,
    activateConstraintLoadAfterNotCleared: false,
    loadAfterInitialStock: false,
    setCurrentTimeToAlgorithm: false,
    orderOperationIdsForSort: [],
    deleteOrderIdsFromOperations: [],
    selectedRelaxedRules: ctx.selectedRelaxedRules,
    priorityLargeTrucks: ctx.priorityLargeTrucks,
    expandWorkingStartTime: settings.expandWorkingStartMinutes,
    expandWorkingEndTime: settings.expandWorkingEndMinutes,
    expandLoadStartTime: settings.expandLoadStartMinutes,
    expandLoadEndTime: settings.expandLoadEndMinutes,
    expandUnloadStartTime: settings.expandUnloadStartMinutes,
    expandUnloadEndTime: settings.expandUnloadEndMinutes,
    expandMaxVolumeRate: settings.expandMaxVolumeRate,
    expandMaxLoadCapacityRate: settings.expandMaxLoadCapacityRate,
    requestAsync: true,
    mlSourceType: 0,
    balancedLoading: settings.balancedLoading,
    autoSplitOrders: settings.autoSplitOrders,
    dontExchangePreroute: settings.dontExchangePreroute,
    concurrentAllOrNothing: settings.concurrentAllOrNothing,
    optimizeForLoad: false,
    forceNullBase: false,
    trunkTransportation: false,
    activateIncrementalMaxNumPistons: settings.activateIncrementalMaxNumPistons,
    traceMode: settings.traceMode,
    traceOnly: settings.traceOnly,
    traceCompanyId: settings.traceCompanyId,
    senario: settings.senario,
    disableGlobalOpt: settings.disableGlobalOpt,
  };
}
